import { Component } from 'react';
import { withServerSideProps } from '@lib/withServerSideProps';
import { ShopDetailsPageDocument } from '@graphql/pages/shop-details.generated';
import type { ServerSidePageProps } from '@lib/withServerSideProps';
import type { ShopDetailsPageViewModel } from '@lib/page-data/shopDetails.map';
import { mapShopDetailsPageData } from '@lib/page-data/shopDetails.map';
import Page from '@ui/components/ams/Pages/Page';
import AMS from '@ui/components/ams';
import { pushPageViewEvent } from '@lib/atm';

class ShopDetails extends Component<ServerSidePageProps<ShopDetailsPageViewModel>> {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
      pageData,
    } = this.props;
    const {
      shopData,
      pageTitle,
    } = pageData;

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        sections: ['brands', 'slug' in shopData ? shopData.slug ?? '' : ''],
        title: pageTitle,
      },
    );
  }

  render() {
    const {
      pageData,
      locale,
      requestData,
      userSessionData,
      globalPageData,
    } = this.props;

    const {
      pageTitle,
      shopData,
      parentCategories,
      subCategories,
      shopConfig,
    } = pageData;

    return (
      <Page
        pageTitle={pageTitle}
        metaDescription={'metaDescription' in shopData ? shopData.metaDescription : undefined}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
      >
        <AMS.ShopPage
          {...shopData}
          parentCategories={parentCategories}
          subCategories={subCategories}
          shopConfig={shopConfig}
          locale={locale}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: ShopDetailsPageDocument,
  getPageQueryVariables: ({ query }) => ({
    shopSlug: Array.isArray(query.shopSlug) ? query.shopSlug[0] : query.shopSlug ?? '',
  }),
  pageDataMapper: mapShopDetailsPageData,
});

export default ShopDetails;
